import { render, staticRenderFns } from "./EventItem1.vue?vue&type=template&id=134fb4b0"
import script from "./EventItem1.vue?vue&type=script&lang=ts"
export * from "./EventItem1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports